import React from 'react';
import PropTypes from 'prop-types';
import api from '../../../Api';

const GroupMemberType = 3;
const GenreContext = React.createContext({});
const { Provider: GenreProvider, Consumer: GenreConsumer } = GenreContext;

export const connectToGenreStore = Component => {
	const WrappedComponent = props => {
		return (
			<GenreConsumer>
				{genreStore => {
					return <Component genreStore={genreStore} {...props} />;
				}}
			</GenreConsumer>
		);
	};

	WrappedComponent.displayName = Component.displayName;

	return WrappedComponent;
};

export default class GenreStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.element,
			PropTypes.arrayOf(PropTypes.element),
		]),
	};

	state = {
		loading: true,
		appUserId: null,
		communities: {},
	};

	render() {
		const store = this.getGenreStore();
		const props = this.props;

		return <GenreProvider value={store}>{props.children}</GenreProvider>;
	}

	componentDidMount() {
		this.fetchUserInfo();
		this.fetchGenreCommunities();
	}

	fetchUserInfo() {
		api.get('/api/me').then(result =>
			this.setState({ appUserId: result.id }),
		);
	}

	fetchGenreCommunities() {
		api.get('/api/affiliations/genre').then(result =>
			this.setState({
				loading: false,
				communities: this.processCommunities(
					result.available,
					result.joined,
				),
			}),
		);
	}

	genreCommunityUrl = (communityId, appUserId) =>
		`/api/affiliations/${communityId}/users/${appUserId}?roleType=${GroupMemberType}`;

	joinGenreCommunity = (communityId, appUserId) => {
		const url = this.genreCommunityUrl(communityId, appUserId);

		api.post(url);
	};

	leaveGenreCommunity = (communityId, appUserId) => {
		const url = this.genreCommunityUrl(communityId, appUserId);

		api.del(url);
	};

	getGenreStore() {
		const state = this.state;
		const communities = state.communities;
		const appUserId = state.appUserId;

		return {
			state,
			toggleCheck: communityId => {
				const community = communities[communityId];
				const newCommunityState = Object.assign({}, community, {
					isChecked: !community.isChecked,
				});

				if (newCommunityState.isChecked) {
					this.joinGenreCommunity(communityId, appUserId);
				} else {
					this.leaveGenreCommunity(communityId, appUserId);
				}

				this.setState({
					communities: {
						...communities,
						[communityId]: newCommunityState,
					},
				});
			},
		};
	}

	processCommunities = (available, joined) => {
		const communities = available.reduce((map, community) => {
			map[community.groupId] = this.processCommunity(community, false);
			return map;
		}, {});

		return joined.reduce((map, community) => {
			map[community.groupId] = this.processCommunity(community, true);
			return map;
		}, communities);
	};

	processCommunity = (community, isChecked) => {
		return {
			id: community.groupId,
			name: community.name,
			isChecked,
		};
	};
}
